webpackJsonp([104981817426404],{

/***/ 632:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/projects/tallegg-tvc.md absPath of file >>> MarkdownRemark","html":"","excerpt":"","tags":["TVC"],"frontmatter":{"date":"August 31, 2026","title":"Tallegg","videoUrl":"https://vimeo.com/1008770780","image":"/img/tallegg.jpg","credits":""}}},"pathContext":{"id":"/opt/build/repo/src/pages/projects/tallegg-tvc.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-tallegg-tvc-5928c07a29e630562f9c.js